define(
    'viewmodels/secured/people/context',[
        "durandal/app",
        "viewmodels/ViewModel",
        "providers/dataprovider"
    ],
    function (app, ViewModel, provider) {

        var vm = new ViewModel({
            persons: ko.observable(),
            personTypes: ko.observable(),
            organisations: ko.observable(),
            teams: ko.observable(),
            cultures: ko.observable()
        });

        vm.tellReload = ko.observable().extend({notify: 'always'});
        vm.init = function () {
            var self = this;

            setTimeout(function() {
                //self.persons([{ displayName: 'hello world' }]);
            },10000);
        };
        vm.loadForPerson = function () {
            var d = $.Deferred();

            //setTimeout(function () {
            $.when(loadPersons(), loadPersonTypes(), loadOrganisations(), loadTeams(), loadCultures())
            .done(function (persons, types, organisations, teams, cultures) {
                vm.persons(persons);
                vm.personTypes(types);
                vm.organisations(organisations);
                vm.teams(teams);
                vm.cultures(cultures);

                d.resolve();
            })
            .fail(function (e) {
                d.reject(e);                    
            });
            //}, 10000);

            return d.promise();
        };
        vm.loadForOrganisation = function () {
            var d = $.Deferred();

            //setTimeout(function () {
            var q = $.when(loadOrganisations());

            q.done(function (organisations) {
                vm.organisations(organisations);

                d.resolve();
            });

            q.fail(function (e) {
                d.reject(e);
            });
            //}, 10000);

            return d.promise();
        };
        vm.loadForTeam = function () {
            var d = $.Deferred();

            //setTimeout(function () {
            var q = $.when(loadTeams());

            q.done(function (teams) {
                vm.teams(teams);

                d.resolve();
            });

            q.fail(function (e) {
                d.reject(e);
            });
            //}, 10000);

            return d.promise();
        };

        return vm;

        function loadPersons() {
            var d = $.Deferred();

            provider
                .persons
                .getPersons()
                .done(function (data) {
                    data = data || [];

                    //data = [];
                    //for (var i = 1; i <= 30; i++) {
                    //    data.push({ "organisation": null, "teams": [], "defaultLibraryId": null, "organisationId": null, "canEditListValues": false, "phone": null, "accessTokenExpiredDate": null, "accountActivatedDate": null, "lastAccessDate": null, "lastAccessIPAddress": null, "id": "51963c0a-b561-4845-9489-8b868985a276", "userName": "rollieclaro@outlook.com", "firstName": "RRR", "lastName": "CCC", "displayName": i, "emailAddress": "rollieclaro@outlook.com", "personType": 0, "cultureCode": "en-US", "expiredDate": null, "accessExpiryDate": null, "resetPasswordLinkSentDate": null, "incorrectLogonAttempts": 0, "isLockedOut": false, "lockOutTime": null });
                    //}                    

                    d.resolve(data);                    
                })
                .fail(function (e) {
                    d.reject('error loading person');
                });

            return d.promise();
        }
        function loadPersonTypes() {
            var d = $.Deferred();

            provider
                .persons
                .getPersonTypes()
                .done(function (data) {
                    data = data || [];
                    d.resolve(data);
                })
                .fail(function (e) {
                    d.reject('error loading person types');
                });

            return d.promise();
        }
        function loadOrganisations() {
            var d = $.Deferred();

            provider
                .organisations
                .getOrganisations()
                .done(function (data) {
                    data = data || [];
                    d.resolve(data);
                })
                .fail(function (e) {
                    d.reject('error loading organisations');
                });

            return d.promise();
        }
        function loadTeams() {
            var d = $.Deferred();

            provider
                .teams
                .getTeams()
                .done(function (data) {
                    data = data || [];
                    d.resolve(data);
                })
                .fail(function (e) {
                    d.reject('error loading teams');
                });

            return d.promise();
        }
        function loadCultures() {
            var d = $.Deferred();

            provider
                .persons
                .getCultures()
                .done(function (data) {
                    data = data || [];
                    d.resolve(data);
                })
                .fail(function (e) {
                    d.reject('error loading cultures');
                });

            return d.promise();
        }
    });
